import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { MwFormBaseSectionComponent } from '../section-base.component';

@Injectable()
export class MwFormBehaviorService {
  get sectionAdded$(): Observable<MwFormBaseSectionComponent> {
    return this._sectionAdded$.asObservable();
  }

  get sectionRemoved$(): Observable<MwFormBaseSectionComponent> {
    return this._sectionRemoved.asObservable();
  }

  private readonly _sectionAdded$ = new Subject<MwFormBaseSectionComponent>();
  private readonly _sectionRemoved = new Subject<MwFormBaseSectionComponent>();

  emitSectionAdded(section: MwFormBaseSectionComponent): void {
    this._sectionAdded$.next(section);
  }

  emitSectionRemoved(section: MwFormBaseSectionComponent): void {
    this._sectionRemoved.next(section);
  }
}
